import da_DK from "./locales/da_DK.json";
import en_US from "./locales/en_US.json";
export default () => ({
  legacy: false,
  locale: "da_DK",
  fallbackLocale: "en_US",
  messages: {
    da_DK,
    en_US
  }
});
